import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { People } from '~/services/Http';

export interface Props {
  listItem: People.AbsenceDto;
  isTabDisabled?: boolean;
}

export const Absence: React.FC<Props> = ({ listItem, isTabDisabled }) => {
  const { t } = useTranslation();

  return (
    <SummaryItem
      key={listItem.uid}
      avatarProps={{
        alt: listItem.employee.firstName,
        src: listItem.employee.profilePic,
      }}
      primaryElement={`${listItem.employee.firstName} ${listItem.employee.lastName}`}
      secondaryElement={`${listItem.reason.value}, ${
        listItem.endDate
          ? `${t('endsOn')} ${moment(listItem.endDate).format('L')}`
          : `${t(
              `${
                moment(listItem.startDate).isBefore(moment())
                  ? 'startedOn'
                  : 'startsOn'
              }`,
              { date: moment(listItem.startDate).format('L') },
            ).toLowerCase()}`
      }`}
      href={
        !isTabDisabled
          ? `/page-ui2-redirect?empId=${listItem.employee.id}&area=people&subarea=PEOP_ABSENCES`
          : ''
      }
    />
  );
};
